module.exports = __webpack_public_path__ + "img/OnlineBG.2d3a4a9b.png";